module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-getting-past-the-addicted-self@2x.12d717f3.png";